<mat-drawer-container class="drawer-container" [dir]="direction">
  <mat-drawer
    #sidebar
    class="pc-sidebar"
    [mode]="modeValue"
    opened
    [ngClass]="{
      compact: currentLayout === 'compact',
      horizontal: currentLayout === 'horizontal'
    }"
    style="background-color: #01172f !important"
  >
    <nav>
      <div class="navbar-wrapper">
        <div class="" style="text-align: center; cursor: pointer" (click)="menuProductos()">
          <img src="../../../../assets/images/application/blue-ocean.png" alt="" style="width: 236px; height: 90px" />
        </div>
        @if (currentLayout === 'vertical') {
          <app-vertical-menu [menus]="menus" />
        }
        @if (currentLayout === 'compact') {
          <app-compact-menu [menus]="menus" />
        }
      </div>
    </nav>
  </mat-drawer>
  <div>
    <app-nav-bar
      [ngClass]="{
        'horizontal-navbar': currentLayout === 'horizontal'
      }"
    />
    @if (currentLayout === 'horizontal') {
      <app-horizontal-menu
        [menus]="menus"
        [ngClass]="{
          'horizontal-menu': currentLayout === 'horizontal'
        }"
      />
    }
    <div class="app-container">
      <app-breadcrumb [dashboard]="true" />
      <div class="main-body">
        <div class="page-wrapper">
          <router-outlet />
        </div>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</mat-drawer-container>
<app-configuration />
